import React, { Component } from 'react'
import jsonlist from '../res/res.json'
import { Button, FormGroup, FormControl, InputGroup, Table } from 'react-bootstrap';

import SimpleStorageContract from '../../build/contracts/LPCoin.json'
import getWeb3 from '../utils/getWeb3'

const imgdivstyle = {
  'width': '333px', 
  'height': '333px', 
  'backgroundColor': '#fff', 
  'margin':'0 auto', 
  'position': 'relative', 
  'borderColor': '#cfcfcf', 
  'borderStyle': 'solid', 
  'borderWidth': '1px'
};

const imgstyle = {
  'position': 'absolute', 
  'margin': 'auto', 
  'top': '0', 
  'left': '0', 
  'right': '0', 
  'bottom': '0',
  'width': 'auto', 
  'height': 'auto', 
  'display': 'block', 
  'maxWidth': "331px",
  'maxHeight': "331px"
};

// const mudata = [0,0,0,0,0,0,0,0,0,0,0,0,0,0];

const contract = require('truffle-contract')
const simpleStorage = contract(SimpleStorageContract)

class WifeDetail extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleLPBChange = this.handleLPBChange.bind(this);
    this.handleCommitChange = this.handleCommitChange.bind(this);

    this.state = {
      LPBvalue: "",
      commit: "",
      web3: null,
      lpbCount: 0,
      charaLPB: "= =",
      charaInfo: jsonlist.datas[this.props.match.params.id],
      userAddressList: [],
      userLPBList: {},
      userCommitList: {},
      sortUserAddressList: [],
      isBtnLoading: false
    };
  }
  
  componentDidMount() {
    getWeb3.then(results => {
      this.setState({ web3: results.web3 })
      this.initCharaLPB()
      this.initSendLPBList()
      this.initMyLPB()
    }).catch(() => {
      console.log('Error finding web3.')
    })
  }

  initCharaLPB() {
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.showAllLPBForChara(this.state.charaInfo.id)
      }).then((result) => {
        this.setState({ charaLPB: result.c[0] });
      })
    })
  }

  initSendLPBList() {
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    // var users = [];

    this.state.web3.eth.getAccounts((error, accounts) => {
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.showUsersForChara(this.state.charaInfo.id)
      }).then((result) => {
          // console.log(result);
        this.setState({ userAddressList: result });
        this.getSendListDetail();
      })
    })
  }

  initMyLPB() {
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      var account = accounts[0];
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.balanceOf(account)
      }).then((result) => {
        this.setState({ lpbCount: result.c[0] });
      })
    })
  }

  getSendListDetail() {
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    var list = this.state.userAddressList;
    var i;
    var userLPB = {};
    var userCommit = {};
    var selfthis = this;

    list.forEach(function(item, i) {
        selfthis.state.web3.eth.getAccounts((error, accounts) => {
            simpleStorage.deployed().then((instance) => {
              simpleStorageInstance = instance
              return simpleStorageInstance.showCharaLPBOnUser(selfthis.state.charaInfo.id, list[i])
            }).then((result) => {
              // console.log(result.c[0]);
              userLPB[list[i]] = result.c[0];
              selfthis.renewUserLPB(userLPB);
            })
          })
          selfthis.state.web3.eth.getAccounts((error, accounts) => {
            simpleStorage.deployed().then((instance) => {
              simpleStorageInstance = instance
              return simpleStorageInstance.showCharaCommitOnUser(selfthis.state.charaInfo.id, list[i])
            }).then((result) => {
              // console.log(result);
              userCommit[list[i]] = result;
              selfthis.renewUserCommit(userCommit);
            })
          })
    });

    // for ( i in list ) {
    //       console.log(i)
    //   this.state.web3.eth.getAccounts((error, accounts) => {
    //     simpleStorage.deployed().then((instance) => {
    //       simpleStorageInstance = instance
    //       return simpleStorageInstance.showCharaLPBOnUser(this.state.charaInfo.id, list[i])
    //     }).then((result) => {
    //       console.log(result.c[0]);
    //       userLPB[list[i]] = result.c[0];
    //       this.renewUserLPB(userLPB);
    //     })
    //   })
    //   this.state.web3.eth.getAccounts((error, accounts) => {
    //     simpleStorage.deployed().then((instance) => {
    //       simpleStorageInstance = instance
    //       return simpleStorageInstance.showCharaCommitOnUser(this.state.charaInfo.id, list[i])
    //     }).then((result) => {
    //       console.log(result);
    //       userCommit[list[i]] = result;
    //       this.renewUserCommit(userCommit);
    //     })
    //   })
    // }
  }

  renewUserLPB(lpblist) {
    this.setState({ userLPBList: lpblist });
    this.rankUserLPBList();
  }

  renewUserCommit(commit) {
    this.setState({ userCommitList: commit });
  }

  rankUserLPBList() {
    var lpblist = this.state.userLPBList;
    // lpblist.key1 = 222;
    // lpblist.key2 = 1;
    // lpblist.key3 = 55;
    // lpblist.key4 = 11;
    // lpblist.key5 = 999;
    // console.log(lpblist)
    var objSorted = Object.keys(lpblist).sort(
      function(a, b){
          return lpblist[b] - lpblist[a];
      }
    );
    // console.log(objSorted)
    this.setState({ sortUserAddressList: objSorted });
  }

  handleClick(e) {
    this.setState({ isBtnLoading: true });

    simpleStorage.setProvider(this.state.web3.currentProvider)
    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      if (error) {
        console.log(error);
      }
      var account = accounts[0];
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.showUserHistory(account)
      }).then((result) => {
        // console.log(result)
        this.sendLPB(result)
      })
    })
  }

  sendLPB(historystr) {
    var lpbvalue = Math.floor(this.state.LPBvalue);

    // var totlevalue = parseInt(this.state.lpbCount)+parseInt(this.state.value);
    if( lpbvalue > this.state.lpbCount ) {
      alert("LPB不足");
      return
    }

    var commit = this.state.commit;
    if (commit.length > 20) {
      commit = commit.slice(0,19)+"…";
    }

    var hisstr = String(Date.parse(new Date()))+","+this.state.charaInfo.title+","+lpbvalue+","+commit+";";
    hisstr += historystr;
    // console.log(hisstr)

    simpleStorage.setProvider(this.state.web3.currentProvider)
    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      if (error) {
        console.log(error);
      }
      var account = accounts[0];
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.sendLPBtoChara(this.state.charaInfo.id, lpbvalue, commit, hisstr, {from: account})
      }).then((result) => {
        // console.log(result)
        this.setState({ isBtnLoading: false });
        this.setState({ charaLPB: this.state.charaLPB+lpbvalue });
      })
    })
  }

  getValidationState() {
    // const length = this.state.value.length;
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
    // return null;
  }

  handleCommitChange(e) {
    this.setState({ commit: e.target.value });
  }

  handleLPBChange(e) {
    this.setState({ LPBvalue: e.target.value });
  }

  handleUserAddressClick(e) {
    this.props.history.push({
      pathname: '/mywife/'+e
    })
  }

  refreshClick() {
    this.initSendLPBList();
  }

  render() {
  	var info = this.state.charaInfo;//jsonlist.datas[this.props.match.params.id]
    return (
      <div className="WifeDetail">
        <main className="container">
        
            <div>
				<div className="col-md-4" style={imgdivstyle}>
					<img style={imgstyle} src={require('../res/thumbnails/'+info.id+'.jpg')} alt="loading..."></img>
				</div>

				<div className="col-md-4">
					<h1>{info.title}</h1>

					<h3 style={{color: "orange"}}>{this.state.charaLPB} LPB</h3>

					<div>
						<form style={{position: "relative", top: 40+"px"}}>
							<FormGroup controlId="formBasicText" validationState={this.getValidationState()} >
								<InputGroup>
									<FormControl type="text" value={this.state.LPBvalue} placeholder="请输入正整数" onChange={this.handleLPBChange} />
									<InputGroup.Addon>.00 LPB</InputGroup.Addon>
								</InputGroup>
								<br />
								<FormControl componentClass="textarea" placeholder="请输入不超过20字的留言，超出将被自动截断" onChange={this.handleCommitChange} />
							</FormGroup>
							<Button bsSize="large" bsStyle="success" block disabled={this.state.isBtnLoading} onClick={this.handleClick.bind(this)}>{this.state.isBtnLoading ? '处理中...' : '确认投币'}</Button>
						</form>

					</div>
					
				</div>
				
			</div>
				
			<div className="col-md-12">
				<br />
				<Table striped condensed hover>
					<thead>
						<tr>
						<th><Button bsStyle="success" onClick={this.refreshClick.bind(this)}>刷新</Button></th>
						<th><h3>投币用户</h3></th>
						<th><h3>投币数</h3></th>
						<th><h3>留言</h3></th>
						</tr>
					</thead>
					<tbody>
						{this.state.sortUserAddressList.map(function(result, reactid) {
							return (
								<tr key={'tr'+reactid}>
								<td><h3>{ reactid > 2 ? reactid+1 : "Top "+String(reactid+1) } </h3></td>
								<td><br /><a style={{'cursor':'pointer'}} onClick={this.handleUserAddressClick.bind(this, result)}>{ result }</a><br /></td>
								<td><br />{ this.state.userLPBList[result] } LPB<br /></td>
								<td><br />{ this.state.userCommitList[result] }<br /></td>
								</tr>
							)
						}.bind(this))}
					</tbody>
				</Table>
			</div>
			

        </main>
      </div>
    );
  }
}

export default WifeDetail



// WEBPACK FOOTER //
// ./src/views/WifeDetail.js